import { ProductResponse } from '../../../services/bff/transactional-credit/dtos/transactional-credit-evaluation.dto'
import { Product } from './ProductsSession'

export const simplifyProducts = (products?: ProductResponse[]): Product[] => {
  if (!products) return []

  return products.flatMap(product =>
    product.offers.map(offer => ({
      id: product.id,
      name: `${product.manufacturer} ${product.model}${product.description ? ` ${product.description}` : ''}`,
      price: offer.price,
      downPayment: offer.downPayment,
      maxDownPaymentRate: offer.maxDownPaymentRate,
      priceMinusDownPayment: offer.priceMinusDownPayment,
      minPriceRate: offer.minPriceRate,
    }))
  )
}

export const calculateMaxAmountPlusDownPayment = (downPaymentRate: number, maxAmount: number) => {
  return maxAmount / (1 - downPaymentRate)
}

export const findProductWithPriceRange = (products?: Product[]): Product | undefined => {
  if (!products) return undefined
  return products.find(product => isProductWithPriceRange(product))
}

export const isProductWithPriceRange = (product: Product) => {
  return product.minPriceRate != 1.0
}

export const calculateMaxDownPayment = (fullPrice: number, price: number) => {
  return fullPrice - price
}

export const calculateDownPayment = (price: number, downPaymentRate: number) => {
  return ((price * downPaymentRate) + ((price * (1 - downPaymentRate)) % 1))
}

export const calculateMaxPrice = (basePrice: number, evaluationMaxAmount: number) => {
  return Math.min(basePrice, evaluationMaxAmount)
}

export const isValueInValidPriceRange = (value: number, minPrice: number, maxPrice: number) => {
  return value >= minPrice && value <= maxPrice
}